import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { Cause } from "../../../../api";
import { useAuth } from "../../../../hooks";

const causeController = new Cause();

export function CauseForm({ cause, close, onReload }) {
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: {
      code: cause?.code || "",
      name: cause?.name || "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required("Code is required"),
      name: Yup.string().required("Name is required"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (cause) {
          await causeController.updateCause(accessToken, cause._id, values);
          toast.success("Cause updated");
        } else {
          await causeController.createCause(accessToken, values);
          toast.success("Cause created");
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || "Error saving");
      } finally {
        setSubmitting(false);
      }
    },
  });

  const capitalize = (v) => v.length > 0 ? v.charAt(0).toUpperCase() + v.slice(1) : v;

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input
        label={<label>Código <span style={{ color: "#C0392B" }}>*</span></label>}
        name="code"
        value={formik.values.code}
        onChange={(e) => formik.setFieldValue("code", capitalize(e.target.value))}
        error={formik.errors.code}
        placeholder="Ej: CAU-001"
      />
      <Form.Input
        label={<label>Causa <span style={{ color: "#C0392B" }}>*</span></label>}
        name="name"
        value={formik.values.name}
        onChange={(e) => formik.setFieldValue("name", capitalize(e.target.value))}
        error={formik.errors.name}
        placeholder="Ej: Caida"
      />
      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        <button type="submit" disabled={formik.isSubmitting} style={{ background: "#4A7FA5", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer", opacity: formik.isSubmitting ? 0.55 : 1 }}>
          {formik.isSubmitting ? "…" : (cause ? "Actualizar" : "Guardar")}
        </button>
        <button type="button" onClick={close} style={{ background: "#9BAFC4", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer" }}>
          Cancelar
        </button>
      </div>
    </Form>
  );
}
